import ahoy from 'ahoy.js';

// Prevent sending data while we're impersonating
// If it's not defined, you're not staff; if it is, see if we're impersonating or not.
if (typeof staff_active_impersonation === 'undefined' || staff_active_impersonation) {
  ahoy.trackView()
}
